export function jqSmoothScroll() {

    jQuery('a[href^="#"]').on('click', function () {
        const speed = 500;
        const easing = 'swing';
    
        const href = $(this).attr('href');
        const target = $(href === '#' || href === '' ? 'html' : href);
    
        // .l-headerのouterHeightを取得（なければ0）
        const headerHeight = $('.l-header').outerHeight() || 0;
    
        // スクロール先位置を計算（ヘッダーの高さ分だけ上に余裕を持たせる）
        const position = target.offset().top - headerHeight;
    
        // スムーズスクロール
        $('html, body').animate({ scrollTop: position }, speed, easing);
    
        return false;
    });

}
